var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trays-types" },
    [
      _c(
        "div",
        {
          staticClass: "trays-types__header",
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        },
        [
          _c("div", { staticClass: "trays-types__header-left" }, [
            _c("div", { staticClass: "trays-types__image-wrapper" }, [
              _c("img", {
                staticClass: "trays-types__image",
                attrs: {
                  src: _vm.link,
                  alt: "Птица, полуфабрикаты, готовая еда",
                },
              }),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "trays-types__title" }, [
              _vm._v(_vm._s(_vm.headerTitle)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "trays-types__header-right" }, [
            _c(
              "svg",
              {
                staticClass: "trays-types__arrow",
                class: { "trays-types__arrow--open": _vm.isOpen },
                attrs: {
                  width: "60",
                  height: "60",
                  viewBox: "0 0 60 60",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M17.5 25L30.002 36.45L42.5 25",
                    stroke: "#0A090B",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "trays-slide" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "trays-types__content",
                class: {
                  "trays-types__content--cols-2": Number(_vm.columns) === 2,
                  "trays-types__content--cols-4":
                    Number(_vm.columns) === 4 || !_vm.columns,
                },
              },
              _vm._l(_vm.cards, function (card, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "trays-types__card" },
                  [
                    _c("h3", { staticClass: "trays-types__card-title" }, [
                      _vm._v(_vm._s(card.title)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "trays-types__details" }, [
                      _c("div", { staticClass: "trays-types__row" }, [
                        _c("span", { staticClass: "trays-types__label" }, [
                          _vm._v("Сварной слой:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "trays-types__value" }, [
                          _vm._v(_vm._s(card.weldLayer)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trays-types__row" }, [
                        _c("span", { staticClass: "trays-types__label" }, [
                          _vm._v("Барьерный слой:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "trays-types__value" }, [
                          _vm._v(_vm._s(card.barrierLayer)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trays-types__row" }, [
                        _c("span", { staticClass: "trays-types__label" }, [
                          _vm._v("Пленка:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "trays-types__value" }, [
                          _vm._v(_vm._s(card.film)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trays-types__row" }, [
                        _c("span", { staticClass: "trays-types__label" }, [
                          _vm._v("Моноупаковка:"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "trays-types__value" }, [
                          _vm._v(_vm._s(card.isMono)),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }